import axios from "axios";
import {
  QualificationCriteria, CompanyProfile,
  PastPerformance, PastPerformanceListResponse,
} from "./adminTypes";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:7071/api";

// Re-use the same auth token infrastructure from api.ts
let _getHeaders: (() => Promise<Record<string, string>>) | null = null;

export function setAdminAuthHeaders(fn: () => Promise<Record<string, string>>) {
  _getHeaders = fn;
}

async function authHeaders(): Promise<Record<string, string>> {
  if (_getHeaders) return _getHeaders();
  return {};
}

// ── Qualification Criteria ──────────────────────────────────────────────────

export async function getCriteria(): Promise<QualificationCriteria> {
  const headers = await authHeaders();
  const response = await axios.get(`${API_BASE}/gov/admin/criteria`, { headers });
  return response.data;
}

export async function updateCriteria(
  data: Partial<{ gate1: any; gate2: any; gate3: any }>
): Promise<{ updated: boolean }> {
  const headers = await authHeaders();
  const response = await axios.put(`${API_BASE}/gov/admin/criteria`, data, { headers });
  return response.data;
}

// ── Company Profile ─────────────────────────────────────────────────────────

export async function getProfile(): Promise<CompanyProfile> {
  const headers = await authHeaders();
  const response = await axios.get(`${API_BASE}/gov/admin/profile`, { headers });
  return response.data;
}

export async function updateProfile(
  data: Partial<CompanyProfile>
): Promise<{ updated: boolean }> {
  const headers = await authHeaders();
  const response = await axios.put(`${API_BASE}/gov/admin/profile`, data, { headers });
  return response.data;
}

// ── Past Performance ────────────────────────────────────────────────────────

export async function getPastPerformance(): Promise<PastPerformanceListResponse> {
  const headers = await authHeaders();
  const response = await axios.get(`${API_BASE}/gov/admin/past-performance`, { headers });
  return response.data;
}

export async function addPastPerformance(
  data: Omit<PastPerformance, "_id" | "created_at" | "updated_at">
): Promise<{ inserted: boolean; record_id: string }> {
  const headers = await authHeaders();
  const response = await axios.post(`${API_BASE}/gov/admin/past-performance`, data, { headers });
  return response.data;
}

export async function updatePastPerformance(
  recordId: string,
  data: Omit<PastPerformance, "_id" | "created_at" | "updated_at">
): Promise<{ updated: boolean }> {
  const headers = await authHeaders();
  const response = await axios.put(`${API_BASE}/gov/admin/past-performance/${recordId}`, data, { headers });
  return response.data;
}

export async function deletePastPerformance(
  recordId: string
): Promise<{ deleted: boolean }> {
  const headers = await authHeaders();
  const response = await axios.delete(`${API_BASE}/gov/admin/past-performance/${recordId}`, { headers });
  return response.data;
}
